export default __webpack_public_path__ + "static/media/OUR OCEANS 2.c7087b71.jpg";